import React from 'react'
import ApiDoc from '../../apidoc'
import api from '../../../../../../api-server/dist/openapi/v0/webhooks.json';

export default props => <ApiDoc spec={api} {...props} />
